// PROMISE
export const fileToBase64 = (file: any): Promise<any> =>
	new Promise((resolve, reject) => {
		const myReader: FileReader = new FileReader()
		myReader.readAsDataURL(file)
		myReader.onloadend = e => {
			resolve(myReader.result)
		}
		myReader.onerror = e => {
			reject(e)
		}
	})

// PROMISE
export const eventToBase64 = async (event: any): Promise<void> =>
	fileToBase64(event.target.files[0])

export const eventToBase64PerFile = async (
	event: any,
	index: number
): Promise<void> => fileToBase64(event.target.files[index])
